// export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
// export const REQUEST_FAILURE = "REQUEST_FAILURE";
// export const ON_REQUEST = "ON_REQUEST";

export const GET_BUS_MONGO_REQUEST = "ADD_CUSTOMER_MONGO_REQUEST";
export const GET_BUS_MONGO_SUCCESS = "ADD_CUSTOMER_MONGO_SUCCESS";
export const GET_BUS_MONGO_FAILURE = "ADD_CUSTOMER_MONGO_FAILURE";

export const GET_BUS_MONGO_ID_SUCCESS = "GET_BUS_MONGO_ID_SUCCESS";
